var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5H20C21.8998 4.5 23.2743 4.50106 24.3225 4.64199C25.3563 4.78098 25.9975 5.04772 26.4749 5.52513C26.9523 6.00253 27.219 6.64373 27.358 7.67754C27.4989 8.72573 27.5 10.1002 27.5 12V20C27.5 21.8998 27.4989 23.2743 27.358 24.3225C27.219 25.3563 26.9523 25.9975 26.4749 26.4749C25.9975 26.9523 25.3563 27.219 24.3225 27.358C23.2743 27.4989 21.8998 27.5 20 27.5H12C10.1002 27.5 8.72573 27.4989 7.67754 27.358C6.64373 27.219 6.00253 26.9523 5.52513 26.4749C5.04772 25.9975 4.78098 25.3563 4.64199 24.3225C4.50106 23.2743 4.5 21.8998 4.5 20V12C4.5 10.1002 4.50106 8.72573 4.64199 7.67754C4.78098 6.64373 5.04772 6.00253 5.52513 5.52513C6.00253 5.04772 6.64373 4.78098 7.67754 4.64199C8.72573 4.50106 10.1002 4.5 12 4.5Z",
    stroke: "#f2f2f2",
    strokeOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6667L16 21.3333",
    stroke: "#f2f2f2",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 16L10.6667 16",
    stroke: "#f2f2f2",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.3690a83219f21793962ed88ba8470144.svg";
export { ForwardRef as ReactComponent };